import { useSelector } from 'react-redux';
import { get } from 'lodash';
import { PersonIcon } from 'tuui';
import { userSelector } from 'modules/taboola-common-frontend-modules/authentication';
import styles from './ActiveUserIcon.module.scss';

export const ActiveUserIcon = () => {
    const user = useSelector(userSelector);

    if (!user.full_name) {
        return <PersonIcon className={styles['user-icon']} />;
    }
    return <span className={styles['user-icon']}>{get(user, 'full_name[0]', '').toUpperCase()}</span>;
};
